import {
  CutLineStrategy,
  CutLineStrategyPartWithContext,
} from "@opstel/geo/GetLinePartsStrategies/CutLineStrategy";
import { Path } from "@opstel/geo/Path";
import { Point } from "@opstel/geo/Point";

export type PositionInTrain = "first" | "middle" | "last";

type ContextType = {
  type: "rectangle" | "roundedRectangle";
};

export function getUnitPoints(points: Point[], position: PositionInTrain, width: number): Point[] {
  if (position === "middle") {
    return points;
  }
  const minWidth = width / 3;
  const path = new Path(points);
  if (path.length < minWidth) {
    return points;
  }
  const rectangle: CutLineStrategyPartWithContext<ContextType> = {
    type: "*",
    context: { type: "rectangle" },
  };
  const roundedRectangle: CutLineStrategyPartWithContext<ContextType> = {
    type: "px",
    value: minWidth,
    context: { type: "roundedRectangle" },
  };
  const parts =
    position === "first" ? [roundedRectangle, rectangle] : [rectangle, roundedRectangle];
  const strategy = new CutLineStrategy(parts);

  const [pathSegment] = path.getPathSegments(strategy, (c) => c?.type === "rectangle");

  return pathSegment.path.points;
}
